module.exports = __webpack_public_path__ + "static/media/LogoSimAnn.f7533997.jpg";